(function () {
  var LOG = '[CookieFix]';
  var STORAGE_KEY = 'avada_cookie_bar_dismissed';
  // Verified directly from the live rendered DOM (not guessed from the
  // minified bundle) - the container has no id, but a stable aria-label.
  var CONTAINER_SELECTOR = '[aria-label="Cookie consent"]';
  var CLOSE_SELECTOR = '.CookiesBar-Pop__Close';
  var dismissed = localStorage.getItem(STORAGE_KEY) === '1';

  console.log(LOG, 'script loaded, dismissed flag currently:', dismissed);

  function removeBanner() {
    var bar = document.querySelector(CONTAINER_SELECTOR);
    if (bar) {
      console.log(LOG, 'removing banner (dismissed flag is set)');
      bar.remove();
    }
  }

  if (dismissed) {
    removeBanner();
    new MutationObserver(removeBanner).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      if (event.target.closest(CLOSE_SELECTOR)) {
        console.log(LOG, 'close button clicked - setting dismissed flag');
        localStorage.setItem(STORAGE_KEY, '1');
      }
    },
    true
  );
})();
